import React, { useState } from "react";

export default function HealthInsurance({ data, onChange }) {
  const [insuranceCard, setInsuranceCard] = useState(
    data?.insurance_card_img || ""
  );

  const handleInputChange = (key, value) => {
    onChange({
      ...data,
      [key]: value,
    });
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setInsuranceCard(file.name); // Store the file name or file object
      handleInputChange("insurance_card_img", file.name); // You can also pass the entire file object
    }
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">
        Health Insurance and Government Scheme Details
      </h2>
      <div className="grid grid-cols-2 gap-6">
        {/* Insurance Provider Name */}
        <div>
          <label className="block mb-1 font-medium">
            Insurance Provider Name
          </label>
          <input
            type="text"
            value={data?.insurance_provider || ""}
            onChange={(e) =>
              handleInputChange("insurance_provider", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Insurance Provider Name"
          />
        </div>

        {/* Policy Number */}
        <div>
          <label className="block mb-1 font-medium">Policy Number</label>
          <input
            type="text"
            value={data?.insurance_policy_number || ""}
            onChange={(e) =>
              handleInputChange("insurance_policy_number", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Policy Number"
          />
        </div>

        {/* Coverage Details */}
        <div>
          <label className="block mb-1 font-medium">Coverage Details</label>
          <textarea
            value={data?.coverage_details || ""}
            onChange={(e) =>
              handleInputChange("coverage_details", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Coverage Details"
          ></textarea>
        </div>

        {/* Government Scheme Name */}
        <div>
          <label className="block mb-1 font-medium">
            Government Scheme Name
          </label>
          <input
            type="text"
            value={data?.scheme || ""}
            onChange={(e) => handleInputChange("scheme", e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Scheme Name"
          />
        </div>

        {/* Scheme ID/Number */}
        <div>
          <label className="block mb-1 font-medium">Scheme ID/Number</label>
          <input
            type="text"
            value={data?.scheme_no || ""}
            onChange={(e) => handleInputChange("scheme_no", e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Scheme ID"
          />
        </div>

        {/* Scheme Coverage Type */}
        <div>
          <label className="block mb-1 font-medium">Scheme Coverage Type</label>
          <select
            value={data?.scheme_type || ""}
            onChange={(e) => handleInputChange("scheme_type", e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
          >
            <option value="">Select Coverage Type</option>
            <option value="cashless">Cashless</option>
            <option value="reimbursement">Reimbursement</option>
          </select>
        </div>

        {/* Select Scheme */}
        <div>
          <label className="block mb-1 font-medium">Select Scheme</label>
          <select
            value={data?.scheme || ""}
            onChange={(e) => handleInputChange("scheme", e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
          >
            <option value="">Choose Scheme</option>
            <option value="Ayushman Bharat">Ayushman Bharat</option>
            <option value="ESI">ESI</option>
            <option value="PMJAY">PMJAY</option>
            <option value="Other">Other</option>
          </select>
        </div>

        {/* Upload Insurance Card */}
        <div>
          <label className="block mb-1 font-medium">
            Upload Insurance Card
          </label>
          <input
            type="file"
            accept=".png, .jpg, .jpeg, .pdf"
            onChange={handleFileUpload}
            className="w-full border border-gray-300 rounded-md p-2"
          />
          {insuranceCard && (
            <p className="mt-2 text-sm text-gray-600">
              Uploaded File: {insuranceCard}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
